export default __webpack_public_path__ + "static/media/theme4.5fc7bb32.png";